export function testIsSmall(): boolean {
    return window.innerWidth < 550;
}
